const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/objectives/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import i18n from '@/common/translations/i18n';
import { readLiveFlag } from '@/common/utils/readLiveFlag';
import { itemPanelSearchSchema } from '@/features/item-panel/searchSchema';
import { objectiveIdSearchParam } from '@/features/objectives/searchSchema';
const objectivesSearchSchema = itemPanelSearchSchema.extend({
  objectiveId: objectiveIdSearchParam,
  jumpToObjectiveId: objectiveIdSearchParam
});
interface ObjectivesBeforeLoadArgs {
  context: {
    flagOverrides: Partial<FlagKeys>;
    flags: Partial<FlagKeys>;
    ldClient: LDClient | undefined;
  };
  params: {
    org: string;
  };
}
export const objectivesBeforeLoad = ({
  context,
  params
}: ObjectivesBeforeLoadArgs) => {
  if (readLiveFlag(context, 'newStrategyViewEnabled')) {
    throw redirect({
      to: '/org/$org',
      params: {
        org: params.org
      },
      replace: true
    });
  }
};
export const Route = createFileRoute('/(app)/org/$org/objectives/')({
  staticData: {
    hideChrome: true,
    topNav: {
      title: i18n.t($ => $.objectives.page.title)
    }
  },
  beforeLoad: objectivesBeforeLoad,
  validateSearch: zodValidator(objectivesSearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});